import { render, staticRenderFns } from "./CustomerOrigin.vue?vue&type=template&id=35fc9226&"
import script from "./CustomerOrigin.vue?vue&type=script&lang=js&"
export * from "./CustomerOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports